import React, { useEffect } from "react";


import BannerSection from "../../shared/components/BannerSection/BannerSection";
import notFoundImg from '../../utils/assets/shared/bg2.png';
import Error404 from "../components/Error404/Error404";
const NotFound = () =>{

    const BannerSectionInfo =
    {
       cardTitle: "It's all right. That's a mistake!",
       cardButtonText: "",
       lengendBackground: notFoundImg
    }
    useEffect(()=>{
        sessionStorage.clear();
    },[])


    return (
        <React.Fragment>
            <BannerSection props={BannerSectionInfo}/>
            <Error404/>

        </React.Fragment>
    );
}

export default NotFound;